export const siteOrigin = (value = 'https://www.kamsled.com') => new URL(value).origin
export const languages = ['en', 'cn', 'es', 'by', 'fr', 'de', 'it']
export function publicId(value) {
  if (typeof value !== 'string' && typeof value !== 'number') return ''
  let text = String(value)
  if (!/^\d+$/.test(text)) {
    try {
      const binary = atob(text.replace(/-/g, '+').replace(/_/g, '/'))
      text = Array.from(binary, (char, i) => String.fromCharCode(char.charCodeAt(0) ^ 'KAMS'.charCodeAt(i % 4))).join('')
    } catch (_) { return '' }
  }
  return /^[1-9]\d*$/.test(text) ? text : ''
}
const keys = {
  productDetail: ['id'], productsSubDetail: ['pid'], productsExtendedDetail: ['pid'],
  newsDetails: ['id'], projectDetail: ['pid']
}
const publicNames = new Set(['index', 'products', 'productDetail', 'productsSubDetail', 'productsExtendedDetail', 'news', 'newsDetails', 'project', 'projectDetail', 'downloads', 'company', 'videos', 'contact', 'custom'])
export function canonicalPath(route) {
  const path = route.path.replace(/\/+$/, '') || '/en'
  const params = new URLSearchParams()
  for (const key of keys[route.name] || []) {
    const id = publicId(route.query?.[key])
    if (id) params.set(key, id)
  }
  return path + (params.toString() ? '?' + params.toString() : '')
}
export function isIndexableRoute(route) {
  if (!publicNames.has(route.name)) return false
  if (route.query?.q || route.query?.search || route.query?.seriesTypeId || route.query?.seriesCategoryId) return false
  return (keys[route.name] || []).every(key => Boolean(publicId(route.query?.[key])))
}
